<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <p>1. Please confirm the accuracy or update/complete the <b>summary of national implementation</b> for your country. This now integrates the <b>de-registration and liens and detention extensions.</b></p>
      <br />
      <div class="title is-2">
        Summary of National Implementation:
      </div>
      <hr />
      <div class="columns">
        <div class="column">
          <div>
            <b>Country:</b> {{ CountryName }}
          </div>
          <div v-if="questions && questions.length > 0">
            <question v-model="questions[0]" @change="change($event, '0')"></question>
            <question v-model="questions[1]" @change="change($event, '1')"></question>
            <question v-model="questions[2]" @change="change($event, '2')"></question>
            <question v-model="questions[3]" @change="change($event, '3')" column></question>
            <question v-model="questions[4]" v-if="x" @change="change($event, '4')"></question>
            <question v-model="questions[5]" v-if="xi" @change="change($event, '5')"></question>
            <question v-model="questions[6]" @change="change($event, '6')"></question>
            <question v-model="questions[7]" v-if="prohibited" @change="change($event, '7')" column></question>
            <question v-model="questions[8]" @change="change($event, '8')"></question>
            <question v-model="questions[9]" @change="change($event, '9')" v-if="treatyOverConflict"></question>
            <question v-model="questions[10]" @change="change($event, '10')"></question>
            <question v-model="questions[11]" @change="change($event, '11')"></question>
            <question v-model="questions[12]" @change="change($event, '12')"></question>
          </div>
          <br /><br />
          <div v-if="IsClosed && !exporting" class="level">
            <div class="level-left">
              <div class="level-item">
                <b-button class="button is-primary" @click="$router.push('/questionnaire/consent')">Back</b-button>
              </div>
              <div class="level-item">
                <b-button class="button is-primary" @click="$router.push('/questionnaire/a/1')">Next</b-button>
              </div>
            </div>
          </div>
          <div v-if="!IsClosed && !exporting" class="level">
            <div class="level-left">
              <div class="level-item">
                <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
              </div>
              <div class="level-item">
                <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button class="button is-primary" @click="save">Save</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        questions: [],
        qpromise: new Promise((resolve, reject) => { })
      }
    },
    props: {
      exporting: Boolean
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      change(model, prop) {
        this.questions[prop].model = model;
        this.questions.splice();
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/consent');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/1');
        });
      },
      async save() {
        const moment = require('moment')
        if (this.questions[0].model != null) {
          this.questions[0].model = moment(this.questions[0].model).format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.questions[1].model != null) {
          this.questions[1].model = moment(this.questions[1].model).format('YYYY-MM-DD HH:mm:ss');
        }

        return this.$http.post("api/questionnaire/save/" + this.$store.getters["currentQuestionnaire"].Id + "/" + this.$store.getters["user"].Id, this.questions)
          .then(resp => {
            if (this.$store.getters['isAdmin']) {
              this.$parent.saveAdminComment(sections.Summary);
            }
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    created() {
      if (this.$store.getters['isAdmin']) {
        this.$parent.getAdminComment(sections.Summary);
      }

      var Id = -1;
      var groupId = -1;
      if (this.exporting) {
        groupId = this.$parent.options.GroupId;
        Id = this.$parent.options.Id;
      }
      else {
        groupId = this.$store.getters.currentQuestionnaire.GroupId;
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      this.qpromise =
        this.$http.post("api/questionnaire/questions", {
          SectionId: sections.Summary, GroupId: groupId, QuestionnaireId: Id,
          ignoreLock: this.exporting
        })
          .then(resp => {
            this.questions = resp.data.Questions;
            this.questions.forEach(question => {
              if (question.type == "date" && question.model != null) {
                question.model = new Date(question.model);
              }
            })
            if (!this.exporting) {
              this.$store.getters.bus.$emit('load-section');
              this.$parent.$parent.lockInfo = { Locker: resp.data.Locker, IsLocker: resp.data.IsLocker, show: true };
            }
          }).catch(err => {
            console.error(err);
          });

      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },

    mounted() {
      var self = this;
      this.qpromise.then(r => {
        self.$store.getters.bus.$emit('loaded', { exporting: self.exporting });
      });
    },

    computed: {
      xi: function () {
        if (this.questions[3].model && this.questions[3].model.some(model => model == 6)) {
          return true;
        } else {
          if (this.questions[5].model) {
            this.questions[5].model = null;
          }
          return false;
        }
      },
      x: function () {
        if (this.questions[3].model && this.questions[3].model.some(model => model == 9)) {
          return true;
        } else {
          if (this.questions[4].model) {
            this.questions[4].model = null;
          }
          return false;
        }
      },
      prohibited: function () {
        if (this.questions[6].model && this.questions[6].model == 12) {
          return true;
        } else {
          if (this.questions[7].model) {
            this.questions[7].model = null;
          }
          return false;
        }
      },
      treatyOverConflict: function () {
        if (this.questions[8].model && this.questions[8].model == 116) {
          return true;
        } else {
          if (this.questions[9].model) {
            this.questions[9].model = null;
          }
          return false;
        }
      },
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      },
      CountryName() {
        if (this.exporting)
          return this.$parent.options.CountryName;
        else
          return this.$store.getters.currentQuestionnaire.CountryName;
      }
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }
</script>
